/**
 * Whether Interview Candidates opens on the shortlist or on the whole table.
 *
 * Out here rather than inside the page because the default is the whole
 * behaviour, and a default with no test is one that drifts. This one did: it
 * read `=== 'true'`, so an absent key meant off — and an absent key is every
 * new user, every new machine and every cleared cache. A screen called
 * Interview Candidates opened on call backs, not-interesteds and location
 * issues. The filter was never broken; it was opt-in, and almost nobody opted
 * in.
 *
 * What the filter means is decided on the server: `latest_call_positive`
 * keeps candidates whose *most recent* call was Interested or Shortlisted.
 * Most recent, not ever — somebody interested in June and unreachable last
 * week is not an interested candidate, and a list built on "has ever" only
 * grows.
 */

export const INTERESTED_ONLY_KEY = 'candidates.interestedOnly';

/**
 * On unless this browser has explicitly said otherwise.
 *
 * `!== 'false'` rather than `=== 'true'`, which inverts only the default: an
 * explicit choice either way is still remembered. The checkbox still reaches
 * the whole table, which one case genuinely needs — an import of two thousand
 * people has no calls yet, so nobody in it has a latest call to be positive,
 * and they would otherwise be invisible on the screen they were imported for.
 */
export function readInterestedOnly(): boolean {
  try {
    return window.localStorage.getItem(INTERESTED_ONLY_KEY) !== 'false';
  } catch {
    // Private browsing, or storage disabled. The filter still works for this
    // session; only the memory of it is lost — so fall back to the default
    // rather than to the opposite of it.
    return true;
  }
}

export function rememberInterestedOnly(on: boolean): void {
  try {
    window.localStorage.setItem(INTERESTED_ONLY_KEY, String(on));
  } catch {
    // As above. Not worth telling anybody about.
  }
}
